import httpProvider from 'Providers/http.js'

export default {
  getEnvironment() {
    return new Promise((resolve, reject) => {
      httpProvider
        .get('/environment')
        .then(response => {
          if (response.data) {
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
